import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { OrderStatusHeading } from "../../../Constant";
import { CHARTS_DATAS } from "../../../Data/Widgets/ChartWidgets";

const OrderStatus = () => {
  return (
    <Col xl="6" lg="12" className="box-col-12 xl-50">
      <Card>
        <CommonCardHeader title={OrderStatusHeading} className="border-bottom-1" />
        <CardBody>
          <div className="chart-container progress-chart">
            {CHARTS_DATAS.map((data, index) => (
              <ReactApexChart key={index} options={data} series={data.series} type="bar" id={`progress${index + 1}`} height={70}/>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderStatus;
